'use client'

import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Script from 'next/script'
import { CHANNEL_IO_LOADER } from '@/lib/thirdParty/channel.io'

const Provider = ({ children }: { children: React.ReactNode }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      ;(window as any).ChannelIO('boot', {
        pluginKey: process.env.NEXT_PUBLIC_CHANNEL_IO_PLUGIN_KEY,
      })
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <Script id="channel-io-loader" strategy="afterInteractive">
        {CHANNEL_IO_LOADER}
      </Script>
      {children}
    </QueryClientProvider>
  )
}

export default Provider
